import "./TaxReceipt.css";
import {useEffect} from "react";

export default function TaxReceipt({ gruhkar,panikar,item, index }) {

    // =========== Parse Box Data ===========
    const boxData = item.Box ? JSON.parse(item.Box) : {};

    // =========== मागणी ===========
    // गृहकर
// रिपेयर किया हुआ कोड:
    const GruhkarOld =safeNumber(gruhkar.ColD);
    const GruhkarRunning = parseFloat(item.Total_groung) || 0; // चालू

    // विजकर
    const VijkarOld = safeNumber(gruhkar.ColG); // बकाया (API मध्ये नाही)
    const VijkarRunning = parseFloat(boxData.box3) || 0; // चालू

    // आरोग्यकर
    const ArogyaOld = safeNumber(gruhkar.ColJ); // बकाया (API मध्ये नाही)
    const ArogyaRunning = parseFloat(boxData.box4) || 0; // चालू

    // पाणीकर
    const PaniOld = safeNumber(panikar.ColD); // बकाया (API मध्ये नाही)
    const PaniRunning = parseFloat(boxData.box6) || 0; // चालू

    // भोमिकर (Negative = Discount)
    const Bhomikar =0;// parseFloat(item.Bhomikar) || 0;

    // =========== Calculations ===========
    // Formula: बकाया + (बकाया/20) + चालू = एकूण (5% addition on arrears)
    const GruhkarTotal = GruhkarOld + (GruhkarOld / 20) + GruhkarRunning;
    const VijkarTotal = VijkarOld + (VijkarOld / 20) + VijkarRunning;
    const ArogyaTotal = ArogyaOld + (ArogyaOld / 20) + ArogyaRunning;
    const PaniTotal = PaniOld + (PaniOld / 20) + PaniRunning;

    // एकूण (Total with Bhomikar)
    const GrandTotal = GruhkarTotal + VijkarTotal + ArogyaTotal + PaniTotal + Bhomikar;

    // =========== Tax Rows Data ===========
    const taxRows = [
        {
            label: "१) गृह कर",
            old: GruhkarOld,
            running: GruhkarRunning,
            total: GruhkarTotal
        },
        {
            label: "२) खाली प्लॉट कर",
            old: 0,
            running: 0,
            total: 0
        },
        {
            label: "३) विद्युत कर",
            old: VijkarOld,
            running: VijkarRunning,
            total: VijkarTotal
        },
        {
            label: "४) आरोग्य / सफाई कर",
            old: ArogyaOld,
            running: ArogyaRunning,
            total: ArogyaTotal
        },
        {
            label: "५) सामान्य पाणी कर",
            old: PaniOld,//
            running: PaniRunning,//
            total: PaniTotal
        },
        {
            label: "६) रिट फी / दंड / सुट",
            old: Bhomikar < 0 ? Bhomikar : 0, // Negative = सुट
            running: Bhomikar > 0 ? Bhomikar : 0, // Positive = दंड
            total: Bhomikar
        },
    ];

    // सुरक्षित रूप से नंबर में बदलने वाला हेल्पर फंक्शन
    function safeNumber(val) {
        if (!val || String(val).trim() === "") return 0; // अगर खाली या null है तो 0
        const parsed = Number(val);
        return isNaN(parsed) ? 0 : parsed; // अगर text (NaN) है तो 0, नहीं तो नंबर
    }
    // =========== Convert to Words ===========
    const convertToWords = (num) => {
        if (num === 0) return "शून्य";
        // Add your number to words conversion logic here
        return num.toFixed(2);
    };

    useEffect(()=>{
        console.log(gruhkar.ColD);
    },[])

    return (
        <div className="receipt-container">
            <div className="receipt">

                {/* Top Header Section */}
                <div className="top-header">
                    <div className="top-title">महा.ग्रा.पं.ले.स.नमुना ९ (क)</div>
                    <div className="top-meta">
                        <span>बुक क्र. ........................</span>
                        <span className="rule-text">नियम ३२ (५) पहा</span>
                        <span>बिल क्र. <span className="bill-no">{index + 1}</span></span>
                    </div>
                </div>

                {/* Main Heading Box */}
                <div className="main-heading-box">
                    <h2>करांची मागणी पावती (बिल)</h2>
                </div>

                {/* Information Lines */}
                <div className="info-section">
                    <div className="line">
                        <span className="flex-1">ग्रामपंचायत {item.GramPanchayat_Name1}____________</span>
                        <span className="flex-1">ता.पं.स. {item.Panchayat_No}__________</span>
                    </div>

                    <div className="line">
                        <span>श्री. / सौ. / श्रीमती {item.Owner_Name}_______________________</span>
                    </div>

                    <div className="line">
                        <span className="flex-3">रा. ______________________________________________________________</span>
                        <span className="flex-1">वार्ड क्र. ....................................</span>
                    </div>

                    <div className="line">
                        <span>खाते / घर क्रमांक {item.Property_No}................... यांजकडून {item.year1} पावेतोच्या</span>
                    </div>
                </div>

                <p className="declaration-text">
                    पुढील कराची रक्कम वसूलीयोग्य आहे.
                </p>

                {/* Tax Details Table */}
                <table className="receipt-table">
                    <thead>
                    <tr>
                        <th rowSpan="2" className="col-tax-name">कराचे नांव</th>
                        <th colSpan="2" className="col-demand">मागणीची रक्कम</th>
                        <th colSpan="2" className="col-total">एकूण रक्कम</th>
                    </tr>
                    <tr>
                        <th className="sub-th">मागील बाकी</th>
                        <th className="sub-th">चालु कर</th>
                        <th className="sub-th-small">रु.</th>
                        <th className="sub-th-small">पै.</th>
                    </tr>
                    </thead>

                    <tbody>
                    {taxRows.map((row, idx) => (
                        <tr key={idx}>
                            <td className="tax-name-cell">{row.label}</td>
                            <td className="text-center">{row.old}</td>
                            <td className="text-center">{row.running}</td>
                            <td className="text-center">{Math.floor(row.total)}</td>
                            <td className="text-center">{Math.round((row.total % 1) * 100)}</td>
                        </tr>
                    ))}

                    <tr className="total-row">
                        <td className="tax-name-cell text-center font-bold">एकूण</td>
                        <td></td>
                        <td></td>
                        <td className="text-center font-bold">{Math.floor(GrandTotal)}</td>
                        <td className="text-center font-bold">{Math.round((GrandTotal % 1) * 100)}</td>
                    </tr>
                    </tbody>
                </table>

                {/* Footer Section */}
                <div className="footer-section">
                    <div className="amount-in-words">
                        अक्षरी रु. {convertToWords(GrandTotal)}
                    </div>

                    <div className="sign-date-row">
                        <div className="date-field">दिनांक : ....................................</div>
                        <div className="designation">सचिव / वसुलकर्ता</div>
                    </div>
                </div>

                {/* Bottom Legal Terms / Rules */}
                <div className="bottom-rules">
                    हे बील आपणास प्राप्त झाल्यापासून देय रकमांचा भरणा १५ दिवसाच्या आत करावा. अन्यथा १२९ (२)
                    अन्वये मागणी रीट बजावण्यात येईल. १) आर्थिक वर्षातील ६ महिन्याचा आत करावा भरणा केल्यास
                    ५% सवलत २) आर्थिक वर्षाच्या थकबाकीवर ५% दंड आकारण्यात येईल.
                </div>

            </div>
        </div>
    );
}
export  function TaxReceiptOld({item,index}) {

    //===========मागणी===============
    //गृहकर
    const GruhkarOld=0;//बकाया
    const GruhkarRunning=0;//चालू

    //विजकर
    const VijkarOld=0;//बकाया
    const VijkarRunning=0;//चालू

    //आरोग्यकर
    const ArogyaOld=0;//बकाया
    const ArogyaRunning=0;//चालू


    return (
        <div className="receipt-container">
            <div className="receipt">

                {/* Top Header Section */}
                <div className="top-header">
                    <div className="top-title">महा.ग्रा.पं.ले.स.नमुना ९ (क)</div>
                    <div className="top-meta">
                        <span>बुक क्र. ........................</span>
                        <span className="rule-text">नियम ३२ (५) पहा</span>
                        <span>बिल क्र. <span  className="bill-no">{index+1}</span></span>
                    </div>
                </div>

                {/* Main Heading Box */}
                <div className="main-heading-box">
                    <h2>करांची मागणी पावती (बिल)</h2>
                </div>

                {/* Information Lines */}
                <div className="info-section">
                    <div className="line">
                        <span className="flex-1">ग्रामपंचायत {item.GramPanchayat_Name1}____________</span>
                        <span className="flex-1">ता.पं.स. {item.Panchayat_No}__________</span>
                    </div>

                    <div className="line">
                        <span>श्री. / सौ. / श्रीमती {item.Owner_Name}_______________________</span>
                    </div>

                    <div className="line">
                        <span className="flex-3">रा. ______________________________________________________________</span>
                        <span className="flex-1">वार्ड क्र. ....................................</span>
                    </div>

                    <div className="line">
                        <span>खाते / घर क्रमांक {item.Property_No}................... यांजकडून २०......./२०........ पावेतोच्या</span>
                    </div>
                </div>

                <p className="declaration-text">
                    पुढील कराची रक्कम वसूलीयोग्य आहे.
                </p>

                {/* Tax Details Table */}
                <table className="receipt-table">
                    <thead>
                    <tr>
                        <th rowSpan="2" className="col-tax-name">कराचे नांव</th>
                        <th colSpan="2" className="col-demand">मागणीची रक्कम</th>
                        <th colSpan="2" className="col-total">एकूण रक्कम</th>
                    </tr>
                    <tr>
                        <th className="sub-th">मागील बाकी</th>
                        <th className="sub-th">चालु कर</th>
                        <th className="sub-th-small">रु.</th>
                        <th className="sub-th-small">पै.</th>
                    </tr>
                    </thead>

                    <tbody>
                    {[
                        {label:"१) गृह कर",old:GruhkarOld,running:GruhkarRunning,total:GruhkarOld+GruhkarRunning},
                        {label:"२) खाली प्लॉट कर",old:0,running:0,total:0},
                        {label:"३) विद्युत कर",old:VijkarOld,running:VijkarRunning,total:VijkarOld+VijkarRunning},
                        {label:"४) आरोग्य / सफाई कर",old:ArogyaOld,running:ArogyaRunning,total:ArogyaOld+ArogyaRunning},
                        {label:"५) सामान्य पाणी कर",old:0,running:0,total:0},
                        {label:"६) रिट फी / दंड / सुट",old:0,running:0,total:0},
                    ].map((item, index) => (
                        <tr key={index}>
                            <td className="tax-name-cell">{item.label}</td>
                            <td>{item.old}</td>
                            <td>{item.running}</td>
                            <td></td>
                            <td>{item.total}</td>
                        </tr>
                    ))}

                    <tr className="total-row">
                        <td className="tax-name-cell text-center">एकूण</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tbody>
                </table>

                {/* Footer Section */}
                <div className="footer-section">
                    <div className="amount-in-words">
                        अक्षरी रु. ____________________________________________________________________________________
                    </div>

                    <div className="sign-date-row">
                        <div className="date-field">दिनांक : ....................................</div>
                        <div className="designation">सचिव / वसुलकर्ता</div>
                    </div>
                </div>

                {/* Bottom Legal Terms / Rules */}
                <div className="bottom-rules">
                    हे बील आपणास प्राप्त झाल्यापासून देय रकमांचा भरणा १५ दिवसाच्या आत करावा. अन्यथा १२९ (२)
                    अन्वये मागणी रीट बजावण्यात येईल. १) आर्थिक वर्षातील ६ महिन्याचा आत करावा भरणा केल्यास
                    ५% सवलत २) आर्थिक वर्षाच्या थकबाकीवर ५% दंड आकारण्यात येईल.
                </div>

            </div>
        </div>
    );
}